// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

export interface AvailabilityBlock {
  id: string;
  dayIndex: number;
  startMinutes: number;
  endMinutes: number;
}

export type AvailabilityMode = 'specific' | 'general';

export const DAY_OF_WEEK_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const;
export const DAY_OF_WEEK_CODES = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;
export type DayOfWeekCode = (typeof DAY_OF_WEEK_CODES)[number];

export const GRID_START_HOUR = 9;
export const GRID_END_HOUR = 18;
export const PX_PER_MINUTE = 1;

export function minutesToHHMM(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
}

export function hhmmToMinutes(time: string): number {
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
}

export function formatMinutesLabel(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const period = h >= 12 ? 'pm' : 'am';
  let hour12 = h;
  if (h === 0) {
    hour12 = 12;
  } else if (h > 12) {
    hour12 = h - 12;
  }
  if (m === 0) {
    return `${hour12}${period}`;
  }
  return `${hour12}:${m.toString().padStart(2, '0')}${period}`;
}
